import { render, staticRenderFns } from "./ServiceSection.vue?vue&type=template&id=68f14cfb&scoped=true&"
import script from "./ServiceSection.vue?vue&type=script&lang=js&"
export * from "./ServiceSection.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSection.vue?vue&type=style&index=0&id=68f14cfb&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f14cfb",
  null
  
)

export default component.exports